var t = $;
 var o = void 0;
var product_type = void 0;
function change(e, o) {
  
   
  console.log(e);
      if (e == 2) {
	 $("input[name='rx-material-color']").click(function(){
     $('.select-prescription .select-options.lens-type label').trigger('click');
     $('#optical--footer .next-button #next-button').prop('disabled', false);
      $('.warning-msg').addClass('d-none');
    	$('#rx-material1').prop('checked', true);
  		//$('#rx-material2').prop('checked', true);
    
       
  		var col_val = $(this).val();
    console.log(col_val);
      	if($(this).prop('checked') == true) 
    	{
   
          $('.prescription-lence-color').val(col_val);
          	$('.upgrade-lens-color').remove();
			$('.product-upgrades-lens ul').append('<li class="upgrade-item upgrade-lens-color"><span class="upgrade-title" data-color="'+col_val+'">Lens Color:</span>'+col_val+'</li>');

        }
      else {	$('.warning-msg').removeClass('d-none');}
  
  });

       }

  if (e == 6) {
    var setcolor= $("li.upgrade-item.upgrade-lens-color span").attr("data-color");  
    console.log(setcolor); 
    if (setcolor != ''){
   
       t(".rx-material1").trigger("click"),
  t(".warning-msg").addClass("d-none"), 
  t('[data-step="6"]').removeClass("done-step"),
  t("#optical--footer .next-button").addClass("d-none"), 
  t("#optical--footer .rx-add-to-cart").removeClass("d-none"),change(7,6)
  
    }
}
  if (t('[data-step="' + e + '"]').addClass("active-step").removeClass("done-step"),
      t(".modal-prescription .header-prescription .prev-arrow").removeClass("d-none"),
      t(".modal-prescription #optical--footer #prev-button").removeClass("d-none"),
      t(".prev-button #prev-button").removeClass("d-none"),
      t('[data-step="' + o + '"]').addClass("done-step"),
      t('[data-step="' + o + '"]').removeClass("active-step"), 5 == o) {
    var n = t(".right-sph").val(),
        i = t(".left-sph").val();
    if (n < parseInt("-3.25") || i < parseInt("-3.25")) {
      var a = t("#optical--footer .product-info .product-price-footer").attr("data-lence-price");
      setTimeout((function() { 
        "" == a && t("body").find(".rx-glass1").trigger("click")
      }), 300)
    }
  }
  5 == e && "0" == t(".pupillary-cyl").val() && "0.00" == t(".left-sph").val() && "0.00" == t(".right-sph").val() && "0.00" == t(".right-cyl").val() && "000" == t(".right-axis").val() && "0.00" == t(".left-cyl").val() && "000" == t(".left-axis").val() && "0" == t(".pupillary-sph").val() && 0 == t("#customCheck2").prop("checked") && "0" == t(".pupillary-sph").val() && t("#optical--footer .next-button #next-button").prop("disabled", !0), 7 == e && (0 == t("#rx-material1").is(":checked") ? t(".sucessfuly-msg").addClass("d-none") : t(".sucessfuly-msg").removeClass("d-none"),
  setTimeout((function() {
    t("#optical--footer .next-button").addClass("d-none"), t("#optical--footer .rx-add-to-cart").removeClass("d-none"),t('[data-step="5"]').addClass("done-step"),t('[data-step="5"]').removeClass("active-step")
  }), 100))
}
t(".prescription-btn1").on("click", function(e) {
  e.preventDefault(), 
    t(".prescription-step-popup").show(), 
    t("body").addClass("overflowHidden"), 
    setTimeout((function() {
    var e = t(".header-prescription").outerHeight(),
        o = t(".footer-prescription").outerHeight();
    t(".content-prescription").css("padding-bottom", o), 
      t(".content-prescription").css("padding-top", e)
  }), 100);
}),
t("body").on("click", ".modal-prescription .header-prescription .close", function(e) {
  t(".prescription-step-popup").hide(),
    t("body").removeClass("overflowHidden"), 
    t('[data-step="1"]').addClass("active-step"),
    t('[data-step="1"]').removeClass("done-step"),
    t(".slide-page-dots li").removeClass("done-step active-step"), 
    t(".slide-page-dots li").eq(0).addClass("active-step"),
    t(".step-wrapper").removeClass("done-step active-step"), 
    t(".step-wrapper").eq(0).addClass("active-step"), 
    t(".prev-arrow,.prev-button button").addClass("d-none")
}),
t("body").on("change", 'input[type="file"]', function(o) {
  if (o.preventDefault(), "" != t(this).val()) {
    t(".upload-button").text("Uploading..."), 
      t(".upload-button").css("pointer-events", "none"), 
      t("#optical--footer .next-button #next-button").prop("disabled", !1);
      var file_data = $('#fileUploads').prop('files')[0];   
      var form_data = new FormData();                  
      form_data.append('file', file_data);
        
    $.ajax({
      	url: "https://prescription.installmultiplepixel.com/lensapp/file-upload",
        method: "POST",
        crossDomain: true,
        contentType: false,
        cache: false,
        enctype: 'multipart/form-data',
        processData: false,
        data: form_data,
      	success: function(data1) { 
        console.log('working');
        t(".prescription-upload").val(data1.file_path);
        t(".upload-button").text("Complete!");
        t(".prescription-method").val("Upload File");
       },error:function(xhr,j1,j2){
        console.log(xhr);
        console.log(j1);
        console.log(j2);
        alert('EEROR')
      }
    });
  }
}),
t(".shopify-product-form .tt-input-counter .minus-btn").on("click", function() {
  t(".shopify-product-form .tt-input-counter input").val(), t(".product-price").attr("data-main-pro-price")
}),
  t(".shopify-product-form .tt-input-counter .plus-btn").on("click", function() {
  var e = t(".shopify-product-form .tt-input-counter input").val(),
      o = t(".product-price").attr("data-normal-pro-price") * e;
  t(".product-price").attr("data-main-pro-price", o)
}),

t("body").on("click", ".content-prescription .select-prescription .select-options label", function() {
  var e = t(this);
  console.log(e);
    console.log('veenit2');
//    if (e == 2) {
//                      }
  setTimeout((function() {
    var type = e.closest(".select-options").find("input").attr("type");
  
    if ("radio" == e.closest(".select-options").find("input").attr("type") && !0 === e.closest(".select-options").find("input").prop("checked"))
      if ("single-vision-clear-without-blue-light" == (o = e.closest(".select-options").find("input").attr("data-lens")) ? t(".warning-msg").removeClass("d-none") : t(".warning-msg").addClass("d-none"), "non-prescription" == o) {
        t(".product-addToCart-overlay").removeClass("d-none");
        var n = t(".product-main").attr("main-proVariantID"),
            i = e.closest(".select-options").find("input").attr("data-variantID"),
            a = t(".shopify-product-form .tt-input-counter input").val(),
            r = t(".random-number").val(),
            s = e.closest(".select-options").find("input").attr("data-lens-price"),
            l = t(".product-price").attr("data-main-pro-price"),
            d = "$" + ((parseInt(s) + parseInt(l)) / 100).toFixed(2);
        console.log('')
        Shopify.queue = [], Shopify.queue.push({
          variantId: n,
          qty: a
        }), Shopify.moveAlong = function() {
          if (Shopify.queue.length) {
            var e = Shopify.queue.shift(),
                o = {
                  id: e.variantId,
                  quantity: e.qty,
                  properties: {
                    "Group ID": r,
                    "Prescription Total Price": d
                  }
                };
            t.ajax({
              type: "POST",
              url: "/cart/add.js",
              dataType: "json",
              data: o,
              async: !1,
              success: function(e) {
                Shopify.moveAlong(), t(".prescription-qty").val(), setTimeout((function() {
                  Shopify.queue = [], Shopify.queue.push({
                    variantId: i
                  }), Shopify.moveAlong = function() {
                    if (Shopify.queue.length) {
                      var e = {
                        id: Shopify.queue.shift().variantId,
                        quantity: 1,
                        properties: {
                          "Group ID": r
                        }
                      };
                      t.ajax({
                        type: "POST",
                        url: "/cart/add.js",
                        dataType: "json",
                        data: e,
                        async: !1,
                        success: function(e) {
                          Shopify.moveAlong(), setTimeout((function() {
                            window.location.href = "/cart"
                          }), 500)
                        },
                        error: function() {
                          Shopify.queue.length && Shopify.moveAlong()
                        }
                      })
                    }
                  }, Shopify.moveAlong()
                }), 1500)
              },
              error: function() {
                Shopify.queue.length && Shopify.moveAlong()
              }
            })
          }
        }, Shopify.moveAlong()
      } else {
        t("#optical--footer .next-button #next-button").prop("disabled", !1),
          e.closest(".modal-prescription").find("#optical--footer .footer-group .next-button #next-button").removeAttr("disabled"), 
          e.closest(".step-wrapper").attr("data-step");
        var c = e.closest(".step-wrapper").attr("data-next-step");
        7 == c ? (t("#optical--footer .next-button").addClass("d-none"),
                  t("#optical--footer .rx-add-to-cart").removeClass("d-none")) : 6 == c ? t("#optical--footer .next-button #next-button").prop("disabled", !0) : (t("#optical--footer .next-button").removeClass("d-none"),
                  t("#optical--footer .rx-add-to-cart").addClass("d-none")), "reading" == o && "4" == c && c++
      }
  }), 100)
}),
  t("body").on("click", ".content-prescription .modal--doctor-prescription .select-options label", function() {
  var o = t(this);
   var e = t(this);
  console.log(o);
  console.log(e);
  
  setTimeout((function() {
    if ("radio" == o.closest(".select-options").find("input").attr("type")) {
      var n = o.closest(".select-options").find("input").prop("checked"),
          i = o.closest(".select-options").find("input").val("checked");
      if (!0 === n && "Upload" != i) {

        t("#optical--footer .next-button #next-button").prop("disabled", !1);
        var a = o.closest(".select-options").find("[data-per-method]").attr("data-value");
   
        t(".prescription-method").val(a), o.closest(".modal-prescription").find("#optical--footer .footer-group .next-button #next-button").removeAttr("disabled");
        var r = o.closest(".step-wrapper").attr("data-step"),
            s = o.closest(".step-wrapper").attr("data-next-step");
        7 == s ? (t("#optical--footer .next-button").addClass("d-none"), t("#optical--footer .rx-add-to-cart").removeClass("d-none")) : 6 == s ? t("#optical--footer .next-button #next-button").prop("disabled", !0) : (t("#optical--footer .next-button").removeClass("d-none"),
        t("#optical--footer .rx-add-to-cart").addClass("d-none")), e(s, r)

      }
      "Upload" == i && t("#optical--footer .next-button #next-button").prop("disabled", !0)
    }
  }), 100)
}),
  t("body").on("click", ".content-prescription .modal--reading-power .select-options label", function() {
  var o = t(this);
  setTimeout((function() {
    if ("radio" == o.closest(".select-options").find("input").attr("type") && !0 === o.closest(".select-options").find("input").prop("checked")) {
      t("#optical--footer .next-button #next-button").prop("disabled", !1);
      var n = o.closest(".select-options").find("input").attr("data-reading-power");
      t(".prescription-reading_power").val(n), o.closest(".modal-prescription").find("#optical--footer .footer-group .next-button #next-button").removeAttr("disabled");
      var i = o.closest(".step-wrapper").attr("data-step"),
          a = o.closest(".step-wrapper").attr("data-next-step");
      6 == a ? (t("#optical--footer .next-button").addClass("d-none"),
                t("#optical--footer .rx-add-to-cart").removeClass("d-none")) : 5 == a || (t("#optical--footer .next-button").removeClass("d-none"), 
                                                                                                                                                 t("#optical--footer .rx-add-to-cart").addClass("d-none")), e(a, i)
    }
  }), 100)
}),   
  t("body").on("click", "#optical--footer .next-button #next-button", function() {
   
      
  if (t(".modal-prescription").find(".step-wrapper").hasClass("active-step")) {
    var n = t(".active-step").attr("data-step"),
        i = t(".active-step").attr("data-next-step");
     //   alert(i);

    
    if ("single-vision-with-clear-anti-blue-light-blocking-technology" == o && 5 == n && (i = 7), 
        7 == i ? (t("#optical--footer .next-button").addClass("d-none"), 
       t("#optical--footer .rx-add-to-cart").removeClass("d-none")) : 5 == i ? "0" == t(".pupillary-cyl").val() && "0.00" == t(".left-sph").val() && "0.00" == t(".right-sph").val() && "0.00" == t(".right-cyl").val() && "000" == t(".right-axis").val() && "0.00" == t(".left-cyl").val() && "000" == t(".left-axis").val() && "0" == t(".pupillary-sph").val() && 0 == t("#customCheck2").prop("checked") && t("#optical--footer .next-button #next-button").prop("disabled", !0) : (t("#optical--footer .next-button").removeClass("d-none"), t("#optical--footer .rx-add-to-cart").addClass("d-none")), "5" == n) {
      var a = "";
      t(".active-step").find("[data-title]").each((function(e, o) {
        if (t(this).attr("data-title").indexOf("right") > -1) {
          var n = t(this).val();
          a += n + ","
        }
      })), a = a.slice(0, a.length - 1), t(".prescription-od").val(a);
      var r = "";
      t(".active-step").find("[data-title]").each((function(e, o) {
        if (t(this).attr("data-title").indexOf("left") > -1) {
          var n = t(this).val();
          r += n + ","
        }
      })), r = r.slice(0, r.length - 1), t(".prescription-os").val(r);
      var s = t('[data-title="pupillary-sph"]').val();
      null != s && (t(".prescription-pd").val(s), t(".prescription-pd-table").text(":" + s));
      var l = t('[data-title="pupillary-cyl"]').val();
      null != l && (t(".prescription-pd2").val(l), t(".prescription-pd2-table").text(":" + l))
    }
    change(i, n);
  }
}),
  t("body").on("click", ".header-prescription .prev-arrow, #optical--footer #prev-button", function() {
   var e = t(this);
  if (e.closest(".modal-prescription").find(".content-prescription").find(".step-wrapper active-step")) {
        
    var n = t(".active-step").attr("data-step"),
        i = t(".active-step").attr("data-prev-step");
    4 == n && e.addClass("d-none"), 7 == n && (t("#optical--footer .next-button").removeClass("d-none"), t("#optical--footer .rx-add-to-cart").addClass("d-none")), "single-vision-with-clear-anti-blue-light-blocking-technology" == o && 7 == n && i--,
      function(e, o) {
      t('[data-step="' + e + '"]').addClass("active-step"), t('[data-step="' + e + '"]').removeClass("done-step"), t('[data-step="' + o + '"]').removeClass("active-step"), 1 == e ? (t(".prev-arrow,.prev-button button").addClass("d-none"), t("#rx-material2,#rx-material1").is(":checked") && t("#next-button").removeAttr("disabled")) : t(".prev-arrow,.prev-button button").removeClass("d-none")
    }(i,n)
    
  }
}),
  t("body").on("change", ".lense-number select", function() {
  "0" == t(".pupillary-sph").val() && "0" == t(".pupillary-cyl").val() ? t("#optical--footer .next-button #next-button").prop("disabled", !0) : t("#optical--footer .next-button #next-button").prop("disabled", !1);
  var e = t(this).val();
  "pupillary-sph" == t(this).attr("data-title") && (e < parseInt("58") || e > parseInt("63") ? t(".update-desc").removeClass("d-none") : t(".update-desc").addClass("d-none"));
  var f = t(this).val();
  "pupillary-sph" == t(this).attr("data-title") && (f > parseInt("58") ? t(".update-desc.pd-info-kids").removeClass("d-none") : t(".update-desc.pd-info-kids").addClass("d-none"));
  var o = t(".right-sph").val(),
      n = t(".left-sph").val();
  o < parseInt("-3.25") || n < parseInt("-3.25") ? (t(".add-blue-glasses").removeClass("d-none"), t(".rx--lens-message").addClass("d-none"), t("[data-lens-price]").html("$50.00")) : (t(".add-blue-glasses").addClass("d-none"), t(".rx--lens-message").removeClass("d-none"), t("[data-lens-price]").html("$0.00")), "0.00" == t(".left-sph").val() && "0.00" == t(".right-sph").val() && "0.00" == t(".right-cyl").val() && "000" == t(".right-axis").val() && "0.00" == t(".left-cyl").val() && "000" == t(".left-axis").val() && "0" == t(".pupillary-sph").val() && t("#optical--footer .next-button #next-button").prop("disabled", !0)
}), 
  t("body").on("click", ".content-prescription .modal--slide-container .lens-type label", function() {
  var e = t(this);
  console.log(e);
  setTimeout((function() {
    if (!0 === e.closest(".select-options").find("input").prop("checked")) {
   
      t(".lensClass").removeClass("product-selected"), e.closest(".select-options").find("input").addClass("product-selected");
    
      var o = e.closest(".select-options").find("input").attr("data-producttitle"),
         // console.log(e.closest(".select-options").find("input").attr("data-producttitle"));
          n = e.closest(".select-options").find("input").attr("data-lens-price");
      t(".prescription-material").val(o), t(".lens-price-prop,.prescription-material-price").val(n);
      var i = e.closest(".select-options").find("input").attr("data-lens"),
          a = e.closest(".select-options").find(".lens-price").text(),
          r = t("[data-main-pro-price]").attr("data-main-pro-price"),
          s = t("#optical--footer .product-info .product-price-footer").attr("data-lence-price");
      if ("" != s) var l = parseInt(a) + parseInt(r) + parseInt(s);
      else l = parseInt(a) + parseInt(r);
      t("[data-total-price]").attr("data-total-price", l);
      var d = (l / 100).toFixed(2);
 t(".rx-product-details .product-price").attr("data-frame-price", a), t("#optical--footer .product-info .product-price-footer").attr("data-frame-price", a), t(".rx-product-details .product-price").attr("data-total-price", l), 
   t("#optical--footer .product-info .product-price-footer").attr("data-total-price", l), 
   t(".rx-product-details .product-price,#optical--footer .product-info .product-price-footer").text("$" + d), 
   t(".prescription-total-price").val("$" + d), t(".product-upgrades-lens").removeClass("d-none"),
      console.log('fff'),
   t(".product-upgrades-lens .product-upgrade li").text(i + " / 1.6")
    } else e.closest(".select-options").find("input").removeClass("product-selected")
      }), 500)
  
  
}),  
  t("body").on("click", ".content-prescription .modal--slide-container .glasses-type label", function() {
  var e = t(this);
  setTimeout((function() {
    console.log('veenit 1');
    e.closest(".select-options").find("input").prop("checked");
    var o = [];
    o.push(".prescription-lens"), o.length > 0 ? (t(".product-upgrades-glass").removeClass("d-none"), t(".product-upgrades-glass .product-upgrade li").text(o)) : t(".product-upgrades-glass").addClass("d-none"), e.closest(".select-options").find("input").addClass("product-selected");
    var n = t("[data-total-price]").attr("data-total-price"),
        i = e.closest(".select-options").find(".glass-price").text(),
        a = e.closest(".select-options").find("input").attr("data-glass");
 
    t(".prescription-lence").val(a), t("#optical--footer .product-info .product-price-footer").attr("data-lence-price", i), t(".prescription-glass-price,.prescription-lence-price").val(i);
    var r = parseInt(i) + parseInt(n);
    t("[data-total-price]").attr("data-total-price", r);
    var s = (r / 100).toFixed(2);
    t(".rx-product-details .product-price,#optical--footer .product-info .product-price-footer").text("$" + s), t(".prescription-total-price").val("$" + s)
  }), 500)
}),
  t("body").on("click", ".two-pds .custom-control label", function() {
  var e = t(this);
  setTimeout((function() {
    !0 === e.closest(".custom-control").find("input").prop("checked") ? (t(".dist2").removeClass("d-none"), t(".no-pd .custom-control input").prop("checked", !1), t("#optical--footer .next-button #next-button").prop("disabled", !1)) : t(".dist2").addClass("d-none")
  }), 500)
}),
  t("body").on("click", ".no-pd .custom-control label", function() {
  var e = t(this);
  setTimeout((function() {
    !0 === e.closest(".custom-control").find("input").prop("checked") && (t(".two-pds .custom-control input").prop("checked", !1), t(".dist2").addClass("hide"))
  }), 500)
}),  
  t("body").on("change", "select.form-control", function(e) {
  var o = t(this),
      n = t(this).val(),
      i = o.attr("data-title");
  t('.product-summary td[data-title="' + i + '"]').html(n)
});
 var n = t(".shopify-product-form .tt-input-counter input").val();
t(".prescription-qty").val(n), t("body").on("change", ".shopify-product-form .tt-input-counter input", function() {
  var e = t(this).val();
  

  t(".prescription-qty").val(e)
}),
  t("body").on("click", ".prescription-addBtn", function(e) {
  e.preventDefault(),
    t(".loader-btn").removeClass("d-none"),
    t(this).addClass("d-none"),
    t(this).prop("disabled", !0);
  var o = {},
      n = t(".prescription-variantId").val(),
      i = t(".prescription-qty").val();
//  	console.log(o),
//     console.log(n),
//     console.log(i),
     Shopify.queue = [],
    t.each(t('input[name*="properties"]').serializeArray(), 
     (function() {
    var e = this.name.replace("properties[", "").replace("]", "");
    o[e] = this.value })), 
    Shopify.queue.push({ variantId: n, qty: i }), 
    
    Shopify.moveAlong = function() {
    if (Shopify.queue.length) {
      var e = {
        id: Shopify.queue.shift().variantId,
        quantity: 1,
        properties: o
      };
      console.log(e);
      t.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: e,
        success: function(e) {
          Shopify.queue = [];
          var o = t(".random-number").val();
          t(".product-selected").each((function() {
            var e = t(this).attr("data-variantid");
                         Shopify.queue.push({
              variantId: e
            })
          })), Shopify.moveAlong = function() {
            if (Shopify.queue.length) {
              var e = {
                id: Shopify.queue.shift().variantId,
                quantity: 1,
                properties: {
                  "Group ID": o
                }
              };
              t.ajax({
                type: "POST",
                url: "/cart/add.js",
                dataType: "json",
                data: e,
                async: !1,
                success: function(e) {
                  Shopify.moveAlong(),
                    window.location.href = "/cart", t(".loader-btn").addClass("d-none"),
                    t(".prescription-addBtn").removeClass("d-none"),
                    t(".prescription-addBtn").prop("disabled", !1)
                  
                },
                error: function() {
                  Shopify.queue.length && Shopify.moveAlong()
                }
              })
            }
          }, Shopify.moveAlong()
        },
        error: function() {
          Shopify.queue.length && Shopify.moveAlong()
        }
      })
    }
  }, Shopify.moveAlong()
}),
  t("body").on("click", ".no-thank", function(t) {
  t.preventDefault(), change(7, 6)
}),
t("body").on("click", ".yes-please", function(o) {
o.preventDefault(), 
  t(".rx-material1").trigger("click"),
  t(".warning-msg").addClass("d-none"), 
  t('[data-step="6"]').removeClass("done-step"),
  t("#optical--footer .next-button").addClass("d-none"), 
  t("#optical--footer .rx-add-to-cart").removeClass("d-none"),change(7,6)
}),
  
  
$(document).ready(function(){
let isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
 if (isMobile) {
	$(".footer-sect .footer_link").hide();
	$(".footer-sect h4").click(function(){
		$(this).next(".footer_link").slideToggle("slow")
		.siblings(".footer_link:visible").slideUp("slow");
		$(this).toggleClass("active");
		$(this).siblings("h4").removeClass("active");
	});
    }	
  /*TECH HELP INFOTECH*/
   /*TECH HELP INFOTECH*/
  $('.sub-inside-col input:radio').change(function() {
    $('#prescrption-material1').prop('checked', true);
    $('#prescrption-material2').prop('checked', false);
    $('#prescrption-material3').prop('checked', false);
  });
  
  $('#prescrption-material1').change(function() {
    $('#prescrptionsub-material1').prop('checked', true);
    var p1_val = $(this).val();
    $('.prescription-type').val(p1_val)
    var p2_val = $('#prescrptionsub-material1').val();
    $('.prescription-material').val(p2_val);
    
    if($('#prescrptionsub-material1').prop('checked')==true) 
    {    
    	$('.product-upgrades-lens ul').remove('.upgrade-type');
    	$('.product-upgrades-lens ul').remove('.upgrade-material');
   
    	$('.product-upgrades-lens ul').append('<li class="upgrade-item upgrade-type"><span class="upgrade-title" >Type:</span>'+p1_val+'</li><li class="upgrade-item upgrade-material"><span class="upgrade-title">Material:</span>'+p2_val+'</li>');
    }     
    
      
    });
  
  	$('#prescrptionsub-material1').change(function(){
      
      	if($(this).prop('checked')==true) 
    	{
    		var p1_val = $('#prescrption-material1').val();
            var p3_val = $(this).val();
            $('.prescription-material').val(p3_val);
          	$('.upgrade-type').remove();
    		$('.upgrade-material').remove();
            $('.product-upgrades-lens ul').append('<li class="upgrade-item upgrade-type"><span class="upgrade-title">Type:</span>'+p1_val+'</li><li class="upgrade-item upgrade-material"><span class="upgrade-title">Material:</span>'+p3_val+'</li>');

        }
  
  
  
  });
  
  	$('#prescrptionsub-material3').change(function(){
      
      	if($(this).prop('checked')==true) 
    	{
    		var p1_val = $('#prescrption-material1').val();
            var p3_val = $('#prescrptionsub-material3').val();
            $('.prescription-material').val(p3_val);
          	$('.upgrade-type').remove();
    		$('.upgrade-material').remove();
            $('.product-upgrades-lens ul').append('<li class="upgrade-item upgrade-type"><span class="upgrade-title">Type:</span>'+p1_val+'</li><li class="upgrade-item upgrade-material"><span class="upgrade-title">Material:</span>'+p3_val+'</li>');

        }
  
  
  
  });
  
  
  $('#prescrption-material2, #prescrption-material3 ').change(function() {
    	$('.sub-inside-col input:radio').prop('checked', false);
    	
  });
  
  $('#prescrption-material2').change(function() {
    
    var p2_val = $(this).val();
    
    if($(this).prop('checked')==true) 
    {
    	$('.prescription-material').val(p2_val);
      	$('.upgrade-type').remove();
    	$('.upgrade-material').remove();
        $('.product-upgrades-lens ul').append('<li class="upgrade-item upgrade-type"><span class="upgrade-title">Type:</span>'+p2_val+'</li><li class="upgrade-item upgrade-material"><span class="upgrade-title">Material:</span>NA</li>');
    
    }
    
  });
                                     
   $('#prescrption-material3').change(function() {
    
    var p2_val = $(this).val();
    
    if($(this).prop('checked')==true) 
    {
    	$('.prescription-material').val(p2_val);
      	$('.upgrade-type').remove();
    	$('.upgrade-material').remove();
        $('.product-upgrades-lens ul').append('<li class="upgrade-item upgrade-type"><span class="upgrade-title">Type:</span>'+p2_val+'</li><li class="upgrade-item upgrade-material"><span class="upgrade-title">Material:</span>NA</li>');
    
    }
    
  });   
  
  $('#rx-material1').change(function() {
    
    $('#rx-material1-black').prop('checked', true);    
    var rx1_val = $(this).val();    
    var rx1_price = $(this).attr('data-lens-price');    
    rx1_price = parseInt(rx1_price);
    
    var p_price = $('.product-price-footer').attr('data-price');    
    p_price = parseInt(p_price);    
    var t_price = rx1_price + p_price;
     var formatPrice = (t_price / 100).toFixed(2);
    var c_val = $('#rx-material1-black').val();
    $('.prescription-lence-color').val(c_val);
    
    if($(this).prop('checked')==true) 
    {
    	$('.prescription-lence').val(rx1_val);
      	$('.prescription-lence-price').val(rx1_price);
      	$('.prescription-total-price').val('$' + formatPrice);
      	$('.lensClass').removeClass('product-selected');
      	$(this).addClass('product-selected');
      	$('.upgrade-lens').remove();
      	$('.upgrade-lens-color').remove();
        $('.product-upgrades-lens ul').append('<li class="upgrade-item upgrade-lens"><span class="upgrade-title">Lens:</span>'+rx1_val+'</li>');
          if (c_val == 'undefined') {
		$('.product-upgrades-lens ul').append('<li class="upgrade-item upgrade-lens-color"><span class="upgrade-title" data-color="'+c_val+'">Lens Color:</span>'+c_val+'</li>');
      } 	$('.warning-msg').addClass('d-none');
      	
    }
    
  });
                                     
   $('#rx-material2').change(function() {
    
    var rx2_val = $(this).val();
     
    var rx2_price = $(this).attr('data-lens-price');
     
    rx2_price = parseInt(rx2_price);
    
    var p_price = $('.product-price-footer').attr('data-price');
    
    p_price = parseInt(p_price);
    
    var t_price = rx2_price + p_price;
         var formatPrice = (t_price / 100).toFixed(2);
    if($(this).prop('checked')==true) 
    {
    	$('.prescription-lence').val(rx2_val);
      	$('.prescription-lence-price').val(rx2_price);
      	$('.prescription-total-price').val('$' +formatPrice);
      	$('.lensClass').removeClass('product-selected');
      	$(this).addClass('product-selected');
    	$('.upgrade-lens').remove();
        $('.product-upgrades-lens ul').append('<li class="upgrade-item upgrade-lens"><span class="upgrade-title">Lens:</span>'+rx2_val+'</li>');
    	$('.warning-msg').removeClass('d-none');
      	
    }
    
  });  
   
   $('#lensthikness-material1').change(function() {
    
    var thick_val = $(this).attr('data-value');
    
    if($(this).prop('checked')==true) 
    {
    	$('.prescription-lence-thickness').val(thick_val);
      	$('.upgrade-thickness').remove();
        $('.product-upgrades-lens ul').append('<li class="upgrade-item upgrade-thickness"><span class="upgrade-title">Thickness:</span>'+thick_val+'</li>');
    
    }
    
  }); 
  
  $('#lensthikness-material2').change(function() {
    
    var thick_val = $(this).attr('data-value');
    
    if($(this).prop('checked')==true) 
    {
    	$('.prescription-lence-thickness').val(thick_val);
      	$('.upgrade-thickness').remove();
        $('.product-upgrades-lens ul').append('<li class="upgrade-item upgrade-thickness"><span class="upgrade-title">Thickness:</span>'+thick_val+'</li>');
    
    }
    
  }); 
 
  t("body").on("click", ".select-prescription .select-options.lens-type label", function() {
  var e = t(this);
     setTimeout(function () {
        var type = e.closest('.select-options').find('input').attr('type');
	
        if (type == 'radio') {
           var is_checked = e.closest('.select-options').find('input').prop('checked');
      
          
        }
         }, 100);
  });
  t(function() {
    //caches a jQuery object containing the header element
    var header = t(".header-fixeds");
    var headerss = t("#shopify-section-header").outerHeight();
    t("#shopify-section-header").height(headerss);
    t(window).scroll(function() {
        var scroll = t(window).scrollTop();

        if (scroll >= 50) {
            header.removeClass('headerfixeds').addClass("headerfixed");
        } else {
            header.removeClass("headerfixed").addClass('headerfixeds');
        }
    });
}); 
  
});
